import React, { useState, useEffect, Fragment } from 'react';
import AppTextInput from '@jumbo/components/Common/formElements/AppTextInput';
import { makeStyles } from '@material-ui/core';

const styles = makeStyles({
  list: {
    scrollbarWidth: 'none' /* Firefox */,
    '-ms-overflow-style': 'none' /* Edge */,
    '&::-webkit-scrollbar': {
      display: 'none',
    } /* Chrome */,
  },
});

function DDLInput({ value, clases, lista, onChange = () => {}, onSelect = () => {}, label = '', error = '', disabled }) {
  //value* => String
  //value: valor del imput
  //clases => String
  //clases: prop de texto que da estilo al Input (className)
  //lista* => Array[String]
  //lista: lista de strings que se desplegara, filtrando segun el Input de texto
  //onChange* => Funtion(a)
  //onChange: funcion de un parametro en la que se retorna el nuevo valor del input (handler / onChange)
  //onSelect* => Funtion(a)
  //onSelect: funcion de un parametro en la que se retorna el indice seleccionado en la lista desplegado (este corresponde a su posicion en el prop de ingreso)

  const classes = styles();
  const [val, setVal] = useState('');
  const [selectedItem, setSelectedItem] = useState(-1);
  const [isSelected, setIsSelected] = useState(false);
  const [listaActual, setListaActual] = useState([]);

  useEffect(() => {
    if ((value && value !== undefined) || value === '') {
      setVal(value);
    }
  }, [value]);

  useEffect(() => {
    var actualList = [];

    if (lista && lista !== undefined) {
      lista.map((item, index) => {
        if (item.toLowerCase().includes(val.toLowerCase())) {
          actualList.push({ val: item, id: index });
        }
        return null;
      });
    }

    setListaActual(actualList);

    if (selectedItem && !(actualList.findIndex(element => parseInt(element.id) === parseInt(selectedItem)) >= 0)) {
      setSelectedItem(-1);
    }
  }, [val, lista, selectedItem]);

  useEffect(() => {
    if (value && value !== undefined) {
      setVal(value);
    }
  }, [value]);

  useEffect(() => {
    if (selectedItem >= 0) {
      var row = document.getElementById(selectedItem.toString());
      var ddl = document.getElementById('ddl');
      if (row && ddl) {
        if (row.getBoundingClientRect().top < ddl.getBoundingClientRect().top) {
          ddl.scrollBy(0, row.getBoundingClientRect().top - ddl.getBoundingClientRect().top);
        }

        if (row.getBoundingClientRect().bottom > ddl.getBoundingClientRect().bottom) {
          ddl.scrollBy(0, row.getBoundingClientRect().bottom - ddl.getBoundingClientRect().bottom);
        }
      }
    }
  }, [selectedItem]);

  const handlerChange = event => {
    setVal(event.target.value);
    onChange(event.target.value);
  };

  const handlerSelect = event => {
    event.preventDefault();
    setIsSelected(true);
  };

  const handlerBlur = event => {
    setTimeout(() => {
      setIsSelected(false);
    }, 150);
  };

  const handlerRowChange = event => {
    setSelectedItem(event.target.id);
  };

  const handleKeys = event => {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      nextRow();
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      prevRow();
    }

    if (event.key === 'Enter') {
      event.preventDefault();
      if (selectedItem >= 0) {
        send();
        setIsSelected(false);
      } else {
        trySend();
      }
    }

    if (event.key === 'Tab') {
      if (selectedItem >= 0) {
        send();
      } else {
        trySend();
      }
    }
  };

  const prevRow = () => {
    const indexInActualList = listaActual.findIndex(element => element.id === parseInt(selectedItem));

    if (listaActual.length > 0 && selectedItem === -1) {
      setSelectedItem(listaActual[listaActual.length - 1].id);
      return;
    }

    if (indexInActualList === 0) {
      setSelectedItem(-1);
      return;
    }

    if (indexInActualList >= 0) {
      setSelectedItem(listaActual[indexInActualList - 1].id);
      return;
    }
  };

  const nextRow = () => {
    const indexInActualList = listaActual.findIndex(element => element.id === parseInt(selectedItem));

    if (listaActual.length > 0 && selectedItem === -1) {
      setSelectedItem(listaActual[0].id);
      return;
    }

    if (listaActual.length > indexInActualList + 1) {
      setSelectedItem(listaActual[indexInActualList + 1].id);
      return;
    }

    if (listaActual.length > 0 && selectedItem === listaActual[listaActual.length - 1].id) {
      setSelectedItem(-1);
      return;
    }
  };

  const ddl = () => {
    if (lista && lista !== undefined) {
      return listaActual.map((item, index) => {
        return item.val.toLowerCase().includes(val.toLowerCase()) ? (
          <div id={item.id} key={item.id} onPointerEnter={handlerRowChange} style={estiloRow(item.id)}>
            {item.val}
          </div>
        ) : null;
      });
    } else {
      return null;
    }
  };

  const estiloRow = index => {
    var res = {};
    if (index === parseInt(selectedItem)) {
      res.backgroundColor = '#1F73FF';
      res.color = 'white';
    }

    return res;
  };

  const estiloDDL = () => {
    var res = {
      border: '1px solid LightGrey',
      position: 'absolute',
      borderRadius: '5px',
      boxShadow: '2px 2px 3px LightGrey',
      backgroundColor: 'white',
      zIndex: '10',
      maxHeight: '20rem',
      maxWidth: '100%',
      overflowY: 'scroll',
    };

    if (!isSelected || listaActual.length === 0) {
      res.display = 'none';
    }
    return res;
  };

  const send = () => {
    if (onSelect && onSelect !== undefined) {
      if (selectedItem >= 0) {
        onSelect(parseInt(selectedItem));
        deseleccionInput();
      }
    }
  };

  const trySend = () => {
    var idx = listaActual.findIndex(element => element.val === val);
    if (idx >= 0) {
      onSelect(parseInt(listaActual[idx].id));
      deseleccionInput();
    }
  };

  const deseleccionInput = () => {
    var input = document.getElementById('filterInput');
    if (input && input !== undefined) {
      input.blur();
    }
  };

  return (
    <Fragment>
      <AppTextInput
        disabled={disabled}
        fullWidth
        variant="outlined"
        type="text"
        autoComplete="off"
        onClick={event => {
          event.preventDefault();
        }}
        onChange={handlerChange !== undefined ? handlerChange : () => {}}
        onSelect={handlerSelect}
        onKeyDown={handleKeys}
        onBlur={handlerBlur}
        style={{}}
        value={value}
        className={clases}
        label={label}
        helperText={error}
      />
      <div
        id="ddl"
        style={estiloDDL()}
        onClick={() => {
          send();
        }}
        className={classes.list}>
        {ddl()}
      </div>
    </Fragment>
  );
}

export default DDLInput;
